const landingDictPT = {
  home: "Início",
  benefits: "Benefícios",
  benefitsExplanation: "Nossa plataforma é uma ferramenta moderna, de fácil acesso e lucrativa.",
  firstBenefit: "Maior integração comercial",
  secondBenefit: "Economia mais leve e potente",
  thirdBenefit: "Oportunidade de lucro instantânea e consistente",
  fourthBenefit: "Gere crédito",
  features: "Recursos",
  howItWorks: "Como funciona",
  meetOurPlans: "Conheça nossos planos",
  join: "Nossos Planos",
  plans: "Planos",
  login: "Entrar",
  whatIsIt: "O marketplace que te recompensa sempre",
  whatIsItExplanation:
    "A Extraconomy é uma plataforma online de economia cooperativa com um sistema de recompensas e geolocalização que permite a particulares e empresas aumentar o seu poder económico e a sua rede de clientes de forma automática e progressiva, através das diversas atividades realizadas no mercado.",
  why: "Por que?",
  greaterBusiness: "Maior integração comercial",
  lighterPowerful: "Economia mais leve e potente",
  instantProfit: "Oportunidade de lucro instantânea e consistente",
  genCredit: "Gere crédito",
  whyShould: "Por que devo me juntar à Extraconomy?",
  seeBelow: "Veja abaixo os recursos da nossa rede social e econômica:",
  extracredit: "Extracredit",
  extracoinExplanation:
    "Registre-se e ganhe Extracredit (consulte as condições). Use o crédito para comprar e/ou compartilhar com seus amigos.",
  indicate: "Ganhe Créditos Extracredit",
  youMayGain: "Indique usuários para sua rede e ganhe créditos Extracredit e dinheiro real.",
  economicNetwork: "Rede Econômica",
  networkOfUsers: "Construa rede de usuários para comprar e vender produtos e serviços.",
  transactionSafety: "Segurança nas Transações",
  ourPlatform:
    "Nossa plataforma é robusta e segura. Você pode comprar, vender e transferir dinheiro com segurança.",
  findEverything: "Encontre Tudo que Precisa",
  weHavePowerfulTool:
    "Temos uma ferramenta poderosa para encontrar o produto que você deseja adquirir em poucos cliques.",
  buyerReviews: "Avaliações de Compradores",
  checkTheReviews:
    "Verifique as avaliações de usuários que compraram o produto que você está procurando.",
  geolocation: "Geolocalização",
  effectiveTools: "Ferramentas eficazes para aumentar automaticamente sua rede econômica.",
  exceptionalTrading: "Negócios Excepcionais",
  saferMoreFrequent: "Trocas mais seguras, frequentes e vantajosas.",
  economicInfluence: "Influência Econômica",
  sellFaster: "Realize vendas mais rápido, compre com mais facilidade, sempre lucrando.",
  howItWorksExplanation:
    "Você recebe recompensas por cada atividade que acontecer na plataforma, na forma de dinheiro e créditos Extracredit que podem ser utilizados dentro do sistema como complemento econômico nas trocas comerciais.",
  contactWhatTele:
    "Para informações sobre o projeto e sobre a abertura do mercado para Partners e Managers em um País, escreva para os seguintes contatos de Whatsapp e Telegram.",
  joinExtraconomy: "Junte-se à Extraconomy.",
  belowArePlans: "Abaixo estão os tipos de planos disponíveis em nosso serviço.",
  learnMore: "Saiba mais",
  doubts: "Dúvidas? ",
  contactToUs: "Entre em contato conosco.",
  contact: "Contato",
  scanQRCode: "Escaneie o QR Code abaixo para nos contactar via WhatsApp ou Telegram:",
  highlights: "Destaques",
  by: " por ",
  video: "Vídeo",
  introVideo: "Vídeo de introdução sobre nossa plataforma:",
  backToHomePage: "Voltar à Página de Início",
  qrCodeExplanation:
    "Para informações sobre o projeto e sobre a abertura do mercado para Partners e Managers em um País, escreva para os seguintes contatos de Whatsapp e Telegram:",
  socialMedia: "Redes Sociais",
  rightsReserved: "Todos os Direitos Reservados",
  checkApp: "Confira nosso aplicativo",
  customerDescription: "Só para compras",
  partnerDescription: "Para vendas e compras",
  managerDescription: "E-commerce + Compras",
  benefitsExtracoinSection: "Benefícios na compra de Extracoin",
  extracoinBenefitTitle1: "2.000 Extracoins: Torne-se um Partner na Extraconomy!",
  extracoinBenefitDescription1:
    "Holders de 2.000 Extracoins recebem um voucher gratuito para se tornarem Partners no Marketplace da Extraconomy. Junte-se à revolução e participe ativamente na formação do futuro da economia digital.",
  extracoinBenefitTitle2: "5.000 Extracoins: Desbloqueie o Status de Seller na Extraconomy!",
  extracoinBenefitDescription2:
    "Holders de 5.000 Extracoins são recompensados com um voucher gratuito para se tornarem Sellers na plataforma Extraconomy. Mostre seus produtos e serviços para uma audiência global.",
  extracoinBenefitTitle3: "15.000 Extracoins: Alcance o Status de Manager na Extraconomy!",
  extracoinBenefitDescription3:
    "Holders de 15.000 Extracoins recebem um voucher exclusivo para se tornarem Managers na Extraconomy. Mergulhe no universo gerencial e contribua para o crescimento de todo o ecossistema.",
  voucherExtracoinText1: "Já tem um ",
  clickHere: "Clique aqui",
  andRegister: "e faça seu registro",
  voucherEmptyError: "O campo do voucher não pode estar vazio.",
  extracoinVoucherError: "O voucher inserido não é válido.",
  startsWith: "Começar com",
  contains: "Contém",
  notContains: "Não Contém",
  endsWith: "Termina com",
  equals: "É igual a",
  notEquals: "Não é igual",
  noFilter: "Sem filtro",
  joinTheLaunchpad: "Junte-se ao Launchpad do nosso token Extracoin no Cryptosmart!",
  popupDesc:
    "Ao adquirir tokens EXC a um preço especial, você receberá em troca um voucher grátis para abrir uma loja online no marketplace Extraconomy, ativando sua renda diária!",
  exclusiveBenefits: "Benefícios Exclusivos",
  popupPartnerTitle: "Torne-se um Partner!",
  popupPartnerDesc:
    "*Ao comprar um mínimo de 2.000 Extracoin você receberá um voucher grátis para abrir uma vetrine de vendas no marketplace Extraconomy.",
  popupSellerTitle: "Desbloqueie o perfil de Seller!",
  popupSellerDesc:
    "*Ao adquirir no mínimo 5.000 Extracoin você receberá um voucher grátis para abrir um e-commerce na plataforma Extraconomy.",
  popupManagerTitle: "Alcance o status de Manager!",
  popupManagerDesc:
    "*Ao comprar um mínimo de 15.000 Extracoin você receberá um voucher exclusivo para abrir uma loja online na Extraconomy com todos os benefícios incluídos.",
  promotionValidUntilEndLaunchpad: "Promoção válida até o final do Launchpad",
  downloadAppAndEarn: "Baixe o aplicativo agora e ganhe 20 euros de créditos imediatamente",
  frequentlyAskedQuestion: "Perguntas Frequentes",
  faqTitle1: "A plataforma Extraconomia é segura?",
  faqAnswer1:
    "Sim, contamos com uma equipe técnica especializada na segurança das informações. Todos os conteúdos, dados e operações financeiras na plataforma estão protegidos contra vários níveis de segurança, para que possamos mitigar o máximo possível de qualquer tipo de ataque informático que possa ser verificado.",
  faqTitle2: "Como posso participar da plataforma?",
  faqAnswer2:
    "Basta criar sua conta gratuita — como Customer, para comprar e ganhar cashback, ou cadastrando seu negócio, se quiser vender.",
  faqTitle3: "Existem taxas de registro para poder vender meus produtos ou serviços?",
  faqAnswer3:
    "Sim, para ter um espaço para a sua montra ou para o seu e-commerce existem 3 planos de vendas com valores e vantagens diferentes dependendo das necessidades de cada utilizador particular e empresarial. Você pode descobrir os Planos diretamente aqui neste site.",
  faqTitle4:
    "Quando realizo atividades promocionais e de vendas na plataforma Extraconomy, tenho vínculo empregatício?",
  faqAnswer4:
    "Não, se você aderiu a um dos 3 planos de vendas você será autônomo e será totalmente responsável por suas despesas. Somente se decidir trabalhar conosco como Promotor você receberá um contrato de Representante de Vendas.",
  faqTitle5: "Como posso solicitar a exclusão da minha conta?",
  faqAnswer5:
    "Para cancelar a sua conta Extraconomy basta fazer login na sua Área Pessoal e depois em Editar Perfil solicitar o cancelamento da conta sem custos adicionais. Ou você pode enviar uma mensagem para o whatsapp +39 351 767 0019, com o assunto “Cancelamento de conta”.",
  faqTitle6: "Sou novo na plataforma, há algum suporte?",
  faqAnswer6:
    "Sim, temos suporte humanizado e dedicado para te ajudar sempre que precisar através dos canais Whatsapp e Telegram que você encontra entre nossos contatos aqui no site.",
  faqTitle7: "Forneci o e-mail errado, e agora?",
  faqAnswer7:
    "Para alterar seu e-mail, você precisará enviar uma mensagem para o whatsapp +39 351 767 0019, com o assunto “Alterar e-mail”, informando todos os dados cadastrais utilizados no cadastro e o e-mail correto.",
  faqTitle8: "Quais são as opções de pagamento?",
  faqAnswer8:
    "Através do PayPal, nosso gateway de pagamento internacional, você pode pagar seu pedido com cartão de crédito, cartão de débito ou conta bancária.",
  faqTitle9: "Quanto custa o frete para minha região?",
  faqAnswer9:
    "Para esse cálculo, a maneira mais fácil é simular seu pedido. Escolha os itens com Frete Pago, adicione-os ao carrinho e finalize a compra, insira seus dados corretamente (muito importante) e ao final do pedido o site mostrará o valor correto do frete. Se você está apenas simulando, não clique em Finalizar Compra e isso não resultará em nenhuma compra real de sua parte. Depois edite os itens e quantidades para ver as diferenças, fique à vontade.",
  faqTitle10: "Como funcionam os créditos adquiridos na Extraconomia?",
  faqAnswer10:
    "Os créditos internos são adquiridos através das diversas atividades realizadas na plataforma (Registos, Compra-Venda e Partilha) sob a forma de cashbacks, prémios e bónus, que podem ser utilizados de forma complementar em compras dentro da plataforma ou em atividades de marketing baseadas nos termos de uso fornecidos para cada perfil de usuário. ",
  faqTitle11:
    "Como posso monitorar e gerenciar meus pagamentos, comissões e bônus recebidos na Extraconomy?",
  faqAnswer11:
    "Ao se cadastrar pela Web e pelo App, você recebe em sua Área Pessoal um escritório virtual onde poderá acompanhar todas as suas receitas financeiras diretas e provenientes do seu círculo econômico.",
  faqTitle12: "Como recebo meus rendimentos financeiros? ",
  faqAnswer12:
    "Os rendimentos económicos diretos e indiretos são creditados na sua conta PayPal, que deverá inserir na sua Área Pessoal. Se você não possui uma conta PayPal, pode criar uma gratuitamente em www.paypal.com.",
  SeeTheRegulationsHere: "Veja aqui o regulamento",
  joinTheLaunchpadButton: "Conheca o regulamento do Launchpad",
  tax: "Taxa",
  workWithUs: "Trabalhe Conosco",
  jobOpportunity: "Oportunidade de emprego",
  workWithUsText1:
    "O sistema Extraconomy oferece a possibilidade de participar no desenvolvimento online e territorial através de figuras-chave (promotor web, embaixador, agente comercial, microinfluenciador, afiliados de mercado) que beneficiarão automaticamente de um sistema de comissões exclusivo, escalável e gratificante.",
  freePlan: "Gratuito",
  salesRepresentativeContract: "Contrato de Representante de Vendas",
  earnCommissionsAndCredits: "Ganhe comissões e créditos",
  developYourNetwork: "Desenvolva sua rede",
  financialCareerAwards: "Prêmios de Carreira Financeira",
  resources: "Recursos",
  blog: "Blog",
  toTheStore: "ACESSAR A LOJA",
  revolutionizeWithExtraconomy: "Revolucione seus negócios com a Extraconomy",
  revolutionizeWithExtraconomyDescription:
    "Transforme seus gastos diários em ganhos e participe de uma economia mais sustentável.",
  iWantToStart: "Eu quero revolucionar a economia.",
  extrapayBalance: "Saldo ExtraPay",
  extracreditBalance: "Saldo Extracredit",
  viewCashback: "Visualizar extrato do cashback",
  partnerPlan: "Plano Parceiro",
  empowerYourBusiness: "Potencialize seu negócio",
  empowerYourBusinessDescription:
    "A Extraconomy é um modelo econômico que une tecnologia, comunidade e cooperação. Criamos um sistema inovador que amplifica o poder econômico das pessoas e sustenta as atividades locais.",
  comercialIntegration: "Maior integração comercial",
  comercialIntegrationDescription:
    "Nossos instrumentos potencializam a integração entre lojas e clientes, baseados no modelo de geolocalização.",
  powerfulEconomy: "Uma economia mais rápida e potente",
  powerfulEconomyDescription:
    "Reforçamos a economia local e ajudamos os comercios locais a ganhar mais visibilidade.",
  instantProfitDescription:
    "Com o círculo econômico ativo, você começa a ganhar dinheiro a partir do momento do registro e o expande com compras e indicações.",
  generateCredit: "Gerar mais crédito",
  generateCreditDescription: "Você pode ganhar dinheiro enquanto faz as compras do dia a dia.",
  advantages: "Temos muitas vantagens para você",
  createAnAccountForFree: "Crie sua conta gratuita e descubra todas as vantagens que o",
  createAnAccountForFree2: "pode lhe oferecer",
  geolocalization: "Geolocalização",
  geolocalizationDescription: "Descubra serviços e empresas locais e reforce a sua região.",
  coperativeEconomy: "Economia cooperativa",
  coperativeEconomyDescription: "Participe ativamente na construção de um futuro mais inclusivo.",
  cashback: "Cashback automático",
  cashbackDescription: "Economize e acumule prêmios em todas as suas compras.",
  pension: "Previdência Integrativa",
  pensionDescription: "Garanta seu futuro com poupança automática para saúde e aposentadoria.",
  contactUs: "Contate-nos no WhatsApp",
  manyAdvantages: "São muitas vantagens!",
  monetaryAlternatives:
    "Use também nossa alternativa monetária, você economizará mais pagando com o ",
  monetaryAlternatives2: "utility-token Extracoin!",
  scrollDown: "Continue a explorar",
  exclusiveResources: "RECURSOS ESPECIAIS",
  whyExtraconomy: "Porque se unir à Extraconomy?",
  whyExtraconomyDescription:
    "Com os recursos da nossa rede social e econômica, você pode potencializar seus ganhos. Descubra todos os vantagens da Extraconomy e junte-se a nós.",
  newAcquisition: "Nova aquisição",
  newSale: "Nova venda",
  localSales: "Venda local com retirada.",
  descExtracredit: "Registre-se e obtenha o Extracredit",
  descExtracreditLink: "(veja as condições).",
  descExtracredit2: "Use o crédito para comprar e/ou compartilhar com seus amigos.",
  descEconomicNetwork:
    "Crie automaticamente uma rede de usuários para comprar e vender produtos e serviços.",
  descTransactionSafety:
    "A nossa plataforma é robusta e segura. Vocé pode comprar, vender e transferir dinheiro de maneira segura.",
  descFindEverything:
    "Temos uma ferramenta poderosa para encontrar o produto que vocé deseja comprar em poucos cliques.",
  plansAdvantages: "VANTAGENS DE CADA PLANO",
  chooseYourPlanTitle: "Escolha o plano que melhor se adapta ao seu perfil.",
  chooseYourPlanDescription:
    "Conheça nossos planos, escolha o que mais se adequa ao seu perfil e faça parte da Extraconomy.",
  noMonthlyFees: "SEM TAXAS MENSAIS",
  noMonthlyPaymentsDesc: "Você não precisará fazer pagamentos mensais.",
  partner: "PARCEIRO",
  naturalPerson: "Pessoa Física",
  salesPlan: "Plano de Vendas",
  selectPlan: "SELECIONAR",
  legalOrNaturalPerson: "Pessoa Física / Pessoa Jurídica",
  featureShowcase: "Vitrine online",
  featureEconomicNetwork: "Rede econômica",
  featureActiveComission: "Comissão ativa",
  featureEcommerce: "E-commerce pessoal",
  featureOnlineStore: "Loja online",
  featureGeolocation: "Geolocalização ativa",
  featureEvrythingIncluded: "Tudo incluso",
  mostPopular: "mais popular",
  doubtsAboutPlans: "Tem dúvidas sobre qual plano é o melhor?",
  doubtsAboutPlansDesc:
    "Envie uma mensagem ao nosso serviço de clientes e ajudaremos vocé a escolher o plano mais adequado para o seu perfil.",
  workWithUsSubtitle: "TRABALHE CONOSCO",
  workWithUsTitle: "Seja um Promotor de Extraconomy e multiplique seus ganhos",
  workWithUsDescription:
    "O sistema Extraconomy oferece a possibilidade de participar do desenvolvimento on-line e territorial por meio de figuras-chave (promotores da web, embaixadores, agentes comerciais, microinfluenciadores, afiliados do mercado), que se beneficiarão automaticamente de um sistema de comissão exclusivo, escalável e recompensador.",
  doYouWantToWork: "Deseja se tornar um Promotor?",
  extracredits: "Receba 500 R$ em crédito extra.",
  moreBonus: "Bônus",
  moreBonusesDescription: "Prêmios de carreira financeira.",
  recurrence: "Recorrência",
  recurrenceDescription: "Desenvolva a sua rede e aumente a sua recorrência de ganhos.",
  comissions: "Comissões",
  comissionsDescription: "Ganhe comissões e créditos.",
  clarify: "Esclareça suas dúvidas",
  frequentlyAskedQuestionDescription:
    "Coletamos algumas perguntas e respostas que podem ajudar vocé na sua escolha.",
  doubtsDescription: "Envie uma mensagem ao nosso time.",
  joinUs: "Junte-se a nós",
  joinUsDescription: "Registre-se e transformaremos a economia, juntos.",
  talkWithUs: "Fale com nossa equipe",
  talkWithUsDescription: "Fale com nossa equipe comercial.",
  needHelp: "Precisa de ajuda?",
  downloadApp: "Baixe nosso app",
  call: "Ligue",
  callDescription: "Entre em contato conosco",
  buyInWhatsapp: "Compre no WhatsApp",
  buyInWhatsappDescription: "Rápido e seguro",
  assistance: "Central de atendimento",
  assistanceDescription: "Tire suas dúvidas",
  followUs: "Siga nossos canais oficiais",
  shippingMethods: "Modalidades de envio",
  partners: "Parceiros",
  discoverExtraconomy: "Descubra Extraconomy",
  rewardsProgram: "Programa de recompensa",
  makeMoneyWithUs: "Ganhe dinheiro",
  sellWithUs: "Venda conosco",
  becomeAffiliate: "Seja um afiliado",
  ourPolicies: "Nossas políticas",
  shippingPolicy: "Politica de envio",
  privacyPolicy: "Politica de privacidade",
  returnPolicy: "Politica de devolução",
  returnsAndRefunds: "Devoluções e substituições",
  partnerPlanDescription: "Para quem está começando a vender on-line.",
  sellerPlanDescription: "Para quem deseja aumentar suas vendas.",
  managerPlanDescription: "Para quem deseja ampliar o seu negócio.",
  planSeller: "VENDEDOR",
  register: "Cadastrar-se",
  activateYourDigitalAccess: "Ative seu acesso digital",
  seoDescription:
    "A Extraconomy é um modelo econômico que une tecnologia, comunidade e cooperação.",

  // --- Landing page redesign translations (lp2*) ---
  lp2HeroTitle: "Vamos juntos revolucionar a economia?",
  lp2HeroDescription: "Transforme seus gastos diários em ganhos e participe de uma economia mais sustentável — feita por você, com quem está ao seu redor.",
  lp2HeroCta: "Eu quero fazer parte dessa economia.",
  lp2HeroMicrocopy: "Sem taxa de adesão para você. Sem letras miúdas.",
  lp2LocalPartner: "Parceiro local",
  lp2ComoFuncionaEyebrow: "Como funciona",
  lp2ComoFuncionaTitle: "Compre, receba benefícios e use de novo.",
  lp2ComoFuncionaDescription: "Você compra na rede, recebe benefícios e pode usá-los em novas compras. Enquanto isso, negócios próximos ganham movimento.",
  lp2Step1Label: "Compre",
  lp2Step1Title: "Compre dentro da rede",
  lp2Step1Desc: "Encontre lojas físicas e vendedores online da Extraconomy.",
  lp2Step2Label: "Receba",
  lp2Step2Title: "Sua compra gera benefícios",
  lp2Step2Desc: "Receba cashback em Extracredit e vantagens pelo Extrapay.",
  lp2Step3Label: "Use",
  lp2Step3Title: "Use na próxima compra",
  lp2Step3Desc: "Seu saldo fica visível na carteira e pode voltar para novas compras.",
  lp2Step4Label: "Faça circular",
  lp2Step4Title: "A rede fica mais forte",
  lp2Step4Desc: "Mais compras atraem novos negócios e aumentam as opções para todos.",
  lp2ChoosePathEyebrow: "Escolha como participar",
  lp2ChoosePathTitle: "Comece pelo que faz mais sentido para você.",
  lp2ChoosePathDescription: "Comprar, vender, indicar negócios ou criar uma rede própria. Os detalhes aparecem quando você quiser saber mais.",
  lp2Card1Eyebrow: "Para quem compra",
  lp2Card1Title: "Comprar",
  lp2Card1Desc: "Compre na rede e receba cashback.",
  lp2Card1Cta: "Saiba mais",
  lp2Card2Eyebrow: "Para quem vende",
  lp2Card2Title: "Vender",
  lp2Card2Desc: "Tenha uma vitrine, loja online ou presença geolocalizada.",
  lp2Card2Cta: "Ver opções",
  lp2Card3Eyebrow: "Para quem conecta",
  lp2Card3Title: "Promover",
  lp2Card3Desc: "Apresente novos negócios e ajude a rede a crescer.",
  lp2Card3Cta: "Conheça o Promotor",
  lp2Card4Eyebrow: "Para empresas",
  lp2Card4Title: "Oferecer benefícios",
  lp2Card4Desc: "Crie benefícios para colaboradores, clientes e parceiros.",
  lp2Card4Cta: "Conheça as soluções",
  lp2HighlightEyebrow: "Para organizações",
  lp2HighlightTitle: "Criar uma rede",
  lp2HighlightDesc: "Tenha um ambiente próprio com a tecnologia Extraconomy.",
  lp2HighlightCta: "Conheça White Label",
  lp2NegocioEyebrow: "PARA PARTNERS, SELLERS E MANAGERS",
  lp2NegocioTitle: "Temos muitas vantagens para você",
  lp2NegocioDescription: "Crie sua conta e descubra todas as vantagens que a Extraconomy pode oferecer ao seu negócio, com um sistema que une tecnologia, comunidade e cooperação.",
  lp2NegocioItem1Title: "Maior integração comercial",
  lp2NegocioItem1Desc: "Conectamos lojas e clientes com base no modelo de geolocalização.",
  lp2NegocioItem2Title: "Economia mais rápida e potente",
  lp2NegocioItem2Desc: "Reforçamos o comércio local e ajudamos negócios a ganhar visibilidade.",
  lp2NegocioItem3Title: "Lucro instantâneo e consistente",
  lp2NegocioItem3Desc: "Você ganha a partir do registro e expande a cada venda e indicação.",
  lp2NegocioItem4Title: "Gerar mais crédito",
  lp2NegocioItem4Desc: "Ganhe enquanto faz as próprias compras do dia a dia.",
  lp2StoreEyebrow: "PARA LOJAS FÍSICAS",
  lp2StoreTitle: "Torne-se um estabelecimento conveniado",
  lp2StoreDescription: "Coloque sua loja no mapa da Extraconomy e seja encontrado por quem já está perto de você — com cadastro gratuito e a maior faixa de cashback do ecossistema.",
  lp2StoreItem1Title: "Cadastro 100% gratuito",
  lp2StoreItem1Desc: "Sem taxa de registro para colocar sua loja física no mapa.",
  lp2StoreItem2Title: "Geolocalização ativa",
  lp2StoreItem2Desc: "Receba automaticamente os clientes mais próximos da sua loja.",
  lp2StoreItem3Title: "Cashback de 1% a 50%",
  lp2StoreItem3Desc: "A maior faixa de cashback entre todos os perfis do ecossistema.",
  lp2StoreItem4Title: "Loja online quando quiser",
  lp2StoreItem4Desc: "Ative um e-commerce próprio nas condições do plano Seller, quando fizer sentido.",
  lp2RecursosEyebrow: "RECURSOS ESPECIAIS · PARA TODOS",
  lp2RecursosTitle: "O potencial que já é seu desde o primeiro clique",
  lp2RecursosDescription: "Não importa se você compra, vende ou administra um negócio — estes recursos já estão disponíveis assim que você entra na Extraconomy.",
  lp2RecursosItem1Title: "Geolocalização",
  lp2RecursosItem1Desc: "Descubra serviços e empresas locais e reforce a sua região.",
  lp2RecursosItem2Title: "Economia cooperativa",
  lp2RecursosItem2Desc: "Participe ativamente na construção de um futuro mais inclusivo.",
  lp2RecursosItem3Title: "Segurança nas transações",
  lp2RecursosItem3Desc: "Compre, venda e transfira dinheiro com segurança.",
  lp2RecursosItem4Title: "Encontre tudo que precisa",
  lp2RecursosItem4Desc: "Uma ferramenta poderosa para encontrar o que deseja em poucos cliques.",
  lp2RecursosCashbackLabel: "€ 16,00 cashback",
  lp2RecursosLocalSaleLabel: "Venda local com retirada",
  lp2EcoTitle: "Quanto mais pessoas participam, mais forte fica o comércio local",
  lp2EcoDescription: "A geolocalização não serve só para encontrar — ela redireciona o consumo para perto de você, num ciclo que se retroalimenta.",
  lp2EcoStep1Title: "Você compra local",
  lp2EcoStep1Desc: "Perto de casa, com cashback garantido.",
  lp2EcoStep2Title: "O vendedor ganha visibilidade",
  lp2EcoStep2Desc: "Via geolocalização, perto de quem já compra dele.",
  lp2EcoStep3Title: "Mais parceiros se cadastram",
  lp2EcoStep3Desc: "Atraídos pelo movimento gerado na região.",
  lp2EcoStep4Title: "Mais opções para você",
  lp2EcoStep4Desc: "E o ciclo recomeça, cada vez mais forte.",
  lp2ContinueExploring: "Continue a explorar",
  lp2Bar1Title: "Potencialize seu negócio",
  lp2Bar1Text: "Veja o que muda para quem tem um negócio na Extraconomy.",
  lp2Bar2Title: "E esse potencial não é só para quem vende.",
  lp2Bar2Text: "É para todo mundo que entra na Extraconomy, desde o primeiro clique.",
  lp2Bar3Title: "E quanto mais gente participa, mais forte fica esse ciclo.",
  lp2Bar3Text: "Veja como cada compra local alimenta o próximo passo.",
  lp2Bar4Title: "Já entendeu como tudo se conecta.",
  lp2Bar4Text: "Hora de fechar esse ciclo e escolher o seu lugar nele.",
  lp2Bar5Title: "Quer ir além e multiplicar seu papel nessa economia?",
  lp2Bar5Text: "Conheça a oportunidade de se tornar um Promotor.",
  lp2PromotorEyebrow: "TRABALHE CONOSCO",
  lp2PromotorTitle: "Seja um Promotor de Extraconomy e multiplique seus ganhos",
  lp2PromotorDescription: "Participe do desenvolvimento online e territorial da rede. Como Promotor, você conecta pessoas e negócios e recebe comissões sobre vendas e parcerias reais.",
  lp2PromotorInfoBox: "Seus ganhos vêm de vendas e parcerias reais — não existe ganho por simplesmente convidar pessoas.",
  lp2PromotorCard1Title: "Conecte pessoas",
  lp2PromotorCard1Desc: "Aproxime pessoas e negócios da rede.",
  lp2PromotorCard2Title: "Conecte negócios",
  lp2PromotorCard2Desc: "Amplie a presença territorial da rede.",
  lp2PromotorCard3Title: "Desenvolva a rede",
  lp2PromotorCard3Desc: "Fortaleça relações comerciais reais.",
  lp2PromotorCard4Title: "Ganhe com vendas",
  lp2PromotorCard4Desc: "Comissões ligadas a vendas e parcerias reais.",
  lp2Profile: "Perfil",
  lp2BadgeProSilver: "Pro Silver",
  lp2BadgeMostPopular: "Start Seller",
  lp2BadgeGeoGold: "Geo Gold",
  lp2BadgeFree: "GRÁTIS",
  lp2CashbackPartner: "Cashback de 1% a 15%",
  lp2CashbackSeller: "Cashback de 1% a 25%",
  lp2CashbackManager: "Cashback de 1% a 35%",
  lp2CashbackCustomer: "Cashback de 1% a 5%",
  lp2StorePlanDesc: "Sua loja física, certificada no mapa.",
  lp2CustomerPlanDesc: "Para quem quer comprar e receber benefícios.",
  lp2FeatureFreeSignup: "Cadastro gratuito",
  lp2FeatureGeoAccount: "Conta geolocalizada",
  lp2FeatureMapCertification: "Certificação no mapa",
  lp2FeatureEligibleCashback: "Cashback nas compras elegíveis",
  lp2FeatureExtracreditWallet: "Carteira Extracredit",
  lp2CtaSelect: "Selecionar",
  lp2CtaCertifyStore: "Certificar loja",
  lp2CtaCreateAccount: "Criar conta",
  lp2PlansEyebrow: "ESCOLHA SEU PERFIL",
  lp2PlansTitle: "Encontre o perfil que combina com você",
  lp2PlansDescription: "Customer e Store são gratuitos. Partner, Seller e Manager são planos de venda para momentos diferentes do seu negócio. Promotor também é gratuito.",
  lp2PlansCalloutTitle: "Perfis gratuitos disponíveis",
  lp2PlansCalloutDesc: "Customer e Store não pagam para começar.",
  lp2Faq1Q: "Como posso participar da plataforma?",
  lp2Faq1A: "Basta criar sua conta gratuita — como Customer, para comprar e ganhar cashback, ou cadastrando seu negócio, se quiser vender.",
  lp2Faq2Q: "A plataforma Extraconomy é segura?",
  lp2Faq2A: "Sim. Todas as transações passam por um sistema robusto de segurança, e seu saldo em Extracredit fica sempre visível na sua carteira.",
  lp2Faq3Q: "Existem taxas de registro para vender?",
  lp2Faq3A: "Customer e Store têm cadastro gratuito. Partner, Seller e Manager têm uma taxa anual, conforme o porte do negócio.",
  lp2Faq4Q: "O que é o Extracoin?",
  lp2Faq4A: "É o nosso token utilitário. Usá-lo reduz a taxa de plataforma nas compras, e ele pode ser negociado em corretoras conectadas.",
  lp2Faq5Q: "Como funciona a rede de Promotores?",
  lp2Faq5A: "Promotores apresentam o ecossistema a novos parceiros e ganham comissão sobre negócios reais — nunca por simplesmente convidar pessoas.",
  lp2FooterColPerfis: "Perfis",
  lp2FooterColGanheDinheiro: "Ganhe dinheiro",
  lp2FooterColPoliticas: "Nossas políticas",
  lp2LinkDescubra: "Descubra Extraconomy",
  lp2LinkEmpresas: "Extraconomy para Empresas",
  lp2LinkTecnologia: "Tecnologia como Serviço",
  lp2LinkMoedas: "Moedas do ecossistema",
  lp2LinkAjuda: "Central de Ajuda",
  lp2LinkPerfisPlanos: "Perfis e planos",
  lp2LinkSejaPromotor: "Seja um Promotor",
  lp2LinkPrivacidade: "Política de privacidade",
  lp2LinkTermos: "Termos de uso",
  lp2FooterAppHeading: "Baixe nosso app",
  lp2CustSeoDescription: "Compre na rede Extraconomy e acompanhe cashback e benefícios em uma conta gratuita.",
  lp2CustBadge: "Customer · gratuito",
  lp2CustH1: "Compre na rede e receba parte do valor de volta.",
  lp2CustHeroDesc: "Sua conta é gratuita. Você encontra negócios da Extraconomy, compra e acompanha seus benefícios em um só lugar.",
  lp2CustCta1: "Criar minha conta",
  lp2CustCta2: "Entender os benefícios",
  lp2CustBenefitsEyebrow: "Para o seu dia a dia",
  lp2CustBenefitsTitle: "Comprar fica mais simples quando o benefício é claro.",
  lp2CustBenefitsDesc: "Você compra como já está acostumado. A diferença é que parte dessa experiência volta para você dentro da rede.",
  lp2CustBenefit1Title: "Encontre negócios próximos",
  lp2CustBenefit1Desc: "Descubra lojas, produtos e serviços que fazem parte da Extraconomy.",
  lp2CustBenefit2Title: "Receba cashback",
  lp2CustBenefit2Desc: "Em compras elegíveis, parte do valor volta para você em Extracredit.",
  lp2CustBenefit3Title: "Acompanhe tudo na carteira",
  lp2CustBenefit3Desc: "Veja saldos e benefícios sem precisar decorar regras.",
  lp2CustExtracreditTitle: "Seu cashback fica fácil de entender.",
  lp2CustExtracreditDesc: "Quando uma compra gera cashback, o valor aparece como Extracredit. 1 Extracredit vale 1 Euro e pode ser usado conforme as regras da rede.",
  lp2CustExtrapayLink: "Conhecer o Extrapay",
  lp2CustPraticaLabel: "Na prática",
  lp2CustStep1Title: "Você compra",
  lp2CustStep1Desc: "Em uma loja ou vendedor da rede.",
  lp2CustStep2Title: "O benefício aparece",
  lp2CustStep2Desc: "Cashback e outros benefícios ficam associados à sua conta.",
  lp2CustStep3Title: "Você usa quando fizer sentido",
  lp2CustStep3Desc: "A carteira mostra o que está disponível.",
  lp2CustFaqEyebrow: "Dúvidas rápidas",
  lp2CustFaqTitle: "Antes de continuar.",
  lp2CustFaqDesc: "Veja apenas o que costuma gerar dúvida nesta etapa.",
  lp2CustFaq1Q: "Preciso pagar para criar uma conta?",
  lp2CustFaq1A: "Não. Customer é o perfil gratuito para quem compra na rede.",
  lp2CustFaq2Q: "Preciso entender Extrapay e EXC antes de comprar?",
  lp2CustFaq2A: "Não. Você pode começar comprando e conhecer esses recursos apenas quando eles aparecerem na sua experiência.",
  lp2CustFaq3Q: "Onde vejo meus benefícios?",
  lp2CustFaq3A: "Os benefícios ficam associados à sua conta e são apresentados na carteira e nas áreas correspondentes da plataforma.",
  lp2CustCtaTitle: "Pronto para começar?",
  lp2CustCtaDesc: "Crie sua conta e descubra a Extraconomy pela parte que mais importa: usar.",
  lp2CustCtaButton: "Criar conta gratuita",
  lp2PartnerSeoDescription: "Plano Partner ProSilver para começar a vender online na Extraconomy.",
  lp2PartnerBadge: "Partner · ProSilver",
  lp2PartnerPill: "ProSilver",
  lp2PartnerH1: "Comece a vender online com sua própria vitrine.",
  lp2PartnerHeroDesc: "Para quem quer dar o primeiro passo nas vendas online dentro da Extraconomy.",
  lp2PartnerCta1: "Escolher Partner",
  lp2PartnerCta2: "Comparar planos",
  lp2PartnerBenefitsEyebrow: "O que você recebe",
  lp2PartnerBenefitsTitle: "Um plano feito para o momento do seu negócio.",
  lp2PartnerBenefitsDesc: "Veja primeiro o que realmente muda na sua operação. Os detalhes completos ficam disponíveis quando precisar.",
  lp2PartnerBenefit1Title: "Sua vitrine na rede",
  lp2PartnerBenefit1Desc: "Apresente produtos e serviços em um espaço próprio.",
  lp2PartnerBenefit2Title: "Até 50 anúncios",
  lp2PartnerBenefit2Desc: "Uma capacidade inicial para organizar sua oferta sem excesso.",
  lp2PartnerBenefit3Title: "Faça parte do ecossistema",
  lp2PartnerBenefit3Desc: "Venda para pessoas que já circulam pela rede Extraconomy.",
  lp2PartnerStat1Label: "Capacidade",
  lp2PartnerStat1Value: "Até 50 anúncios",
  lp2PartnerStat2Label: "Registro",
  lp2PartnerStat2Value: "€150/ano",
  lp2PartnerStat3Label: "Renovação",
  lp2PartnerStat3Value: "€15/ano",
  lp2PartnerStatsDisclaimer: "Valores e condições devem ser confirmados no momento da contratação. Esta página apresenta a estrutura comercial do plano de forma resumida.",
  lp2PartnerFaqEyebrow: "Dúvidas rápidas",
  lp2PartnerFaqTitle: "Antes de continuar.",
  lp2PartnerFaqDesc: "Veja apenas o que costuma gerar dúvida nesta etapa.",
  lp2PartnerFaq1Q: "Posso mudar de plano depois?",
  lp2PartnerFaq1A: "A estrutura foi organizada para acompanhar o crescimento da operação. Consulte as condições vigentes para alterações de plano.",
  lp2PartnerFaq2Q: "Existe mensalidade?",
  lp2PartnerFaq2A: "Os planos apresentados trabalham com cobrança anual e renovação anual, conforme as condições de cada modalidade.",
  lp2PartnerFaq3Q: "Preciso decidir agora?",
  lp2PartnerFaq3A: "Não. Compare os planos e escolha apenas quando as diferenças fizerem sentido para sua operação.",
  lp2PartnerCtaTitle: "Esse é o momento do Partner?",
  lp2PartnerCtaDesc: "Faça o cadastro e continue com os dados da sua operação.",
  lp2PartnerCtaButton: "Escolher Partner",
  lp2SellerSeoDescription: "Plano Seller StartSeller para ampliar sua operação de vendas online.",
  lp2SellerBadge: "Seller · StartSeller",
  lp2SellerPill: "Mais popular",
  lp2SellerH1: "Já vende online? Dê mais espaço para sua operação.",
  lp2SellerHeroDesc: "O Seller é para quem precisa ampliar catálogo e presença sem complicar a rotina.",
  lp2SellerCta1: "Escolher Seller",
  lp2SellerCta2: "Comparar planos",
  lp2SellerBenefitsEyebrow: "O que você recebe",
  lp2SellerBenefitsTitle: "Um plano feito para o momento do seu negócio.",
  lp2SellerBenefitsDesc: "Veja primeiro o que realmente muda na sua operação. Os detalhes completos ficam disponíveis quando precisar.",
  lp2SellerBenefit1Title: "Catálogo maior",
  lp2SellerBenefit1Desc: "Até 500 anúncios para uma operação que já ganhou escala.",
  lp2SellerBenefit2Title: "Venda dentro da rede",
  lp2SellerBenefit2Desc: "Conecte sua oferta ao marketplace Extraconomy.",
  lp2SellerBenefit3Title: "Mais espaço para crescer",
  lp2SellerBenefit3Desc: "Uma estrutura intermediária para quem já tem rotina de vendas.",
  lp2SellerStat1Label: "Capacidade",
  lp2SellerStat1Value: "Até 500 anúncios",
  lp2SellerStat2Label: "Registro",
  lp2SellerStat2Value: "€350/ano",
  lp2SellerStat3Label: "Renovação",
  lp2SellerStat3Value: "€35/ano",
  lp2SellerStatsDisclaimer: "Valores e condições devem ser confirmados no momento da contratação. Esta página apresenta a estrutura comercial do plano de forma resumida.",
  lp2SellerFaqEyebrow: "Dúvidas rápidas",
  lp2SellerFaqTitle: "Antes de continuar.",
  lp2SellerFaqDesc: "Veja apenas o que costuma gerar dúvida nesta etapa.",
  lp2SellerFaq1Q: "Posso mudar de plano depois?",
  lp2SellerFaq1A: "A estrutura foi organizada para acompanhar o crescimento da operação. Consulte as condições vigentes para alterações de plano.",
  lp2SellerFaq2Q: "Existe mensalidade?",
  lp2SellerFaq2A: "Os planos apresentados trabalham com cobrança anual e renovação anual, conforme as condições de cada modalidade.",
  lp2SellerFaq3Q: "Preciso decidir agora?",
  lp2SellerFaq3A: "Não. Compare os planos e escolha apenas quando as diferenças fizerem sentido para sua operação.",
  lp2SellerCtaTitle: "Esse é o momento do Seller?",
  lp2SellerCtaDesc: "Faça o cadastro e continue com os dados da sua operação.",
  lp2SellerCtaButton: "Escolher Seller",
  lp2ManagerSeoDescription: "Plano Manager GeoGold para operações com catálogo amplo e alcance territorial.",
  lp2ManagerBadge: "Manager · GeoGold",
  lp2ManagerPill: "GeoGold",
  lp2ManagerH1: "Mais alcance para uma operação que já cresceu.",
  lp2ManagerHeroDesc: "O Manager reúne recursos para negócios com catálogo amplo e necessidades territoriais maiores.",
  lp2ManagerCta1: "Escolher Manager",
  lp2ManagerCta2: "Comparar planos",
  lp2ManagerBenefitsEyebrow: "O que você recebe",
  lp2ManagerBenefitsTitle: "Um plano feito para o momento do seu negócio.",
  lp2ManagerBenefitsDesc: "Veja primeiro o que realmente muda na sua operação. Os detalhes completos ficam disponíveis quando precisar.",
  lp2ManagerBenefit1Title: "Anúncios ilimitados",
  lp2ManagerBenefit1Desc: "Estruture um catálogo amplo sem um teto de anúncios.",
  lp2ManagerBenefit2Title: "Presença territorial",
  lp2ManagerBenefit2Desc: "Recursos de geolocalização apoiam operações com alcance maior.",
  lp2ManagerBenefit3Title: "Operação mais completa",
  lp2ManagerBenefit3Desc: "Uma camada pensada para estruturas comerciais mais maduras.",
  lp2ManagerStat1Label: "Capacidade",
  lp2ManagerStat1Value: "Anúncios ilimitados",
  lp2ManagerStat2Label: "Registro",
  lp2ManagerStat2Value: "€1.500/ano",
  lp2ManagerStat3Label: "Renovação",
  lp2ManagerStat3Value: "€150/ano",
  lp2ManagerStatsDisclaimer: "Valores e condições devem ser confirmados no momento da contratação. Esta página apresenta a estrutura comercial do plano de forma resumida.",
  lp2ManagerFaqEyebrow: "Dúvidas rápidas",
  lp2ManagerFaqTitle: "Antes de continuar.",
  lp2ManagerFaqDesc: "Veja apenas o que costuma gerar dúvida nesta etapa.",
  lp2ManagerFaq1Q: "Posso mudar de plano depois?",
  lp2ManagerFaq1A: "A estrutura foi organizada para acompanhar o crescimento da operação. Consulte as condições vigentes para alterações de plano.",
  lp2ManagerFaq2Q: "Existe mensalidade?",
  lp2ManagerFaq2A: "Os planos apresentados trabalham com cobrança anual e renovação anual, conforme as condições de cada modalidade.",
  lp2ManagerFaq3Q: "Preciso decidir agora?",
  lp2ManagerFaq3A: "Não. Compare os planos e escolha apenas quando as diferenças fizerem sentido para sua operação.",
  lp2ManagerCtaTitle: "Esse é o momento do Manager?",
  lp2ManagerCtaDesc: "Faça o cadastro e continue com os dados da sua operação.",
  lp2ManagerCtaButton: "Escolher Manager",
  lp2StoreSeoDescription: "Cadastre gratuitamente sua loja física no mapa da Extraconomy.",
  lp2StoreBadge: "Store · gratuito",
  lp2StoreH1: "Coloque sua loja no mapa da Extraconomy.",
  lp2StoreHeroDesc: "Cadastre seu negócio físico gratuitamente e fique mais fácil de encontrar por pessoas que já fazem parte da rede.",
  lp2StoreCta1: "Cadastrar minha loja",
  lp2StoreCta2: "Ver como funciona",
  lp2StoreBenefitsEyebrow: "Sua loja na rede",
  lp2StoreBenefitsTitle: "Mais visibilidade perto de quem já está procurando.",
  lp2StoreBenefitsDesc: "A Store é a forma simples de colocar um negócio físico dentro do ecossistema.",
  lp2StoreBenefit1Title: "Apareça no mapa",
  lp2StoreBenefit1Desc: "Ajude pessoas da sua região a encontrar seu negócio.",
  lp2StoreBenefit2Title: "Entre para a rede",
  lp2StoreBenefit2Desc: "Faça parte de uma comunidade de consumidores, vendedores e promotores.",
  lp2StoreBenefit3Title: "Comece sem custo",
  lp2StoreBenefit3Desc: "O cadastro Store é gratuito e pensado para facilitar a entrada de negócios locais.",
  lp2StoreLocalEyebrow: "Para negócios locais",
  lp2StoreLocalTitle: "Sua presença física continua importante.",
  lp2StoreLocalDesc: "A Extraconomy usa a tecnologia para aproximar pessoas de negócios reais. A Store ajuda sua loja a fazer parte dessa descoberta local.",
  lp2StoreLocalPhotoAlt: "Negócio local atendendo um cliente",
  lp2StoreFaqEyebrow: "Dúvidas rápidas",
  lp2StoreFaqTitle: "Antes de continuar.",
  lp2StoreFaqDesc: "Veja apenas o que costuma gerar dúvida nesta etapa.",
  lp2StoreFaq1Q: "O cadastro Store é gratuito?",
  lp2StoreFaq1A: "Sim. Store é a entrada gratuita para negócios físicos.",
  lp2StoreFaq2Q: "Preciso vender online?",
  lp2StoreFaq2A: "Não. O perfil Store existe para a presença física. Se quiser vender online depois, você pode conhecer os planos Partner, Seller e Manager.",
  lp2StoreFaq3Q: "A loja aparece para pessoas próximas?",
  lp2StoreFaq3A: "A proposta do perfil inclui presença geolocalizada dentro da rede, conforme os recursos disponíveis na plataforma.",
  lp2StoreCtaTitle: "Sua loja já pode fazer parte.",
  lp2StoreCtaDesc: "Cadastre os dados básicos do negócio e comece com o perfil gratuito Store.",
  lp2StoreCtaButton: "Cadastrar loja",
  lp2WhiteLabelSeoDescription: "Crie uma rede própria com a infraestrutura White Label da Extraconomy.",
  lp2WhiteLabelBadge: "White Label",
  lp2WhiteLabelH1: "Uma rede com a identidade da sua organização.",
  lp2WhiteLabelHeroDesc: "Use a tecnologia Extraconomy para reunir pessoas, negócios e benefícios em um ambiente próprio.",
  lp2WhiteLabelCta1: "Quero conversar",
  lp2WhiteLabelCta2: "Ver como funciona",
  lp2WhiteLabelBenefitsEyebrow: "Sua rede, sua identidade",
  lp2WhiteLabelBenefitsTitle: "A tecnologia fica por trás. Sua comunidade fica na frente.",
  lp2WhiteLabelBenefitsDesc: "Associações, empresas e organizações podem usar a infraestrutura Extraconomy sem precisar explicar toda a complexidade técnica aos seus participantes.",
  lp2WhiteLabelBenefit1Title: "Identidade própria",
  lp2WhiteLabelBenefit1Desc: "A experiência pode assumir a identidade visual e a comunicação da organização.",
  lp2WhiteLabelBenefit2Title: "Rede de negócios",
  lp2WhiteLabelBenefit2Desc: "Reúna participantes e negócios em um ambiente comum.",
  lp2WhiteLabelBenefit3Title: "Benefícios conectados",
  lp2WhiteLabelBenefit3Desc: "Estruture vantagens e relações dentro da lógica do seu ecossistema.",
  lp2WhiteLabelStepsEyebrow: "Da ideia ao uso",
  lp2WhiteLabelStepsTitle: "Três passos para começar.",
  lp2WhiteLabelStepsDesc: "A implantação pode ser aprofundada depois. Primeiro, precisamos entender quem faz parte da sua rede e o que ela precisa tornar possível.",
  lp2WhiteLabelStep1Label: "01 · Entender",
  lp2WhiteLabelStep1Title: "Quem faz parte da sua rede?",
  lp2WhiteLabelStep1Desc: "Começamos pelas pessoas, negócios e relações que já existem.",
  lp2WhiteLabelStep2Label: "02 · Configurar",
  lp2WhiteLabelStep2Title: "Quais benefícios fazem sentido?",
  lp2WhiteLabelStep2Desc: "A estrutura é organizada em torno do objetivo da organização.",
  lp2WhiteLabelStep3Label: "03 · Lançar",
  lp2WhiteLabelStep3Title: "Uma experiência simples para usar.",
  lp2WhiteLabelStep3Desc: "A complexidade técnica fica nos bastidores; a participação precisa continuar clara.",
  lp2WhiteLabelCtaTitle: "Quer criar uma rede própria?",
  lp2WhiteLabelCtaDesc: "Conte quem você reúne e o que quer tornar possível.",
  lp2WhiteLabelCtaButton: "Conversar sobre White Label",
  lp2PromoterSeoDescription: "Seja Promotor Extraconomy e ajude a rede a crescer na sua região.",
  lp2PromoterBadge: "Promotor · gratuito",
  lp2PromoterH1: "Conecte bons negócios à rede.",
  lp2PromoterHeroDesc: "O Promotor apresenta a Extraconomy, aproxima pessoas e empresas e ajuda o ecossistema a crescer de forma local.",
  lp2PromoterCta1: "Quero ser Promotor",
  lp2PromoterCta2: "Entender o papel",
  lp2PromoterBenefitsEyebrow: "O que você faz",
  lp2PromoterBenefitsTitle: "Você abre portas. A rede faz o resto.",
  lp2PromoterBenefitsDesc: "O papel do Promotor é aproximar novos negócios da Extraconomy e apoiar o primeiro contato com o ecossistema.",
  lp2PromoterBenefit1Title: "Apresente a ideia",
  lp2PromoterBenefit1Desc: "Explique de forma simples como um negócio pode entrar na rede.",
  lp2PromoterBenefit2Title: "Crie conexões reais",
  lp2PromoterBenefit2Desc: "Aproxime pessoas e empresas que podem gerar valor umas para as outras.",
  lp2PromoterBenefit3Title: "Fortaleça sua região",
  lp2PromoterBenefit3Desc: "Ajude a rede a crescer com negócios que existem perto de você.",
  lp2PromoterPayEyebrow: "Remuneração",
  lp2PromoterPayTitle: "A remuneração acompanha atividade real.",
  lp2PromoterPayDesc: "As regras de remuneração fazem parte do plano de compensação e estão ligadas às condições e atividades previstas pela Extraconomy. O cadastro, por si só, não deve ser tratado como uma venda.",
  lp2PromoterChecklistTitle: "Antes de começar",
  lp2PromoterChecklist1: "Entenda como a Extraconomy funciona para explicar com clareza.",
  lp2PromoterChecklist2: "Conecte negócios que tenham aderência real à rede.",
  lp2PromoterChecklist3: "Consulte o plano de compensação antes de assumir qualquer expectativa de ganho.",
  lp2PromoterCtaTitle: "Quer ajudar a rede a crescer?",
  lp2PromoterCtaDesc: "Comece pelo cadastro e conheça as regras antes de atuar.",
  lp2PromoterCtaButton: "Quero ser Promotor",
  lp2EmpresasSeoDescription: "Leve a Extraconomy para colaboradores, clientes e parceiros com soluções de welfare, ESG e relacionamento B2B.",
  lp2EmpresasBadge: "Para empresas",
  lp2EmpresasH1: "Benefícios que fazem sentido para quem está com você.",
  lp2EmpresasHeroDesc: "Leve a Extraconomy para colaboradores, clientes e parceiros com soluções de welfare, ESG e relacionamento B2B.",
  lp2EmpresasCta1: "Falar com a Extraconomy",
  lp2EmpresasCta2: "Conhecer White Label",
  lp2EmpresasBenefitsEyebrow: "Soluções para empresas",
  lp2EmpresasBenefitsTitle: "Uma rede de benefícios pode começar de formas diferentes.",
  lp2EmpresasBenefitsDesc: "Escolha o ponto que combina com sua estratégia e aprofunde apenas onde fizer sentido.",
  lp2EmpresasBenefit1Title: "Welfare e benefícios",
  lp2EmpresasBenefit1Desc: "Crie vantagens para pessoas ligadas à sua empresa.",
  lp2EmpresasBenefit2Title: "ESG com relação local",
  lp2EmpresasBenefit2Desc: "Aproxime consumo, negócios e impacto dentro de uma rede mais próxima.",
  lp2EmpresasBenefit3Title: "Relações B2B",
  lp2EmpresasBenefit3Desc: "Conecte empresas e oportunidades comerciais dentro do ecossistema.",
  lp2EmpresasWhiteLabelEyebrow: "Também para associações",
  lp2EmpresasWhiteLabelTitle: "Quer uma rede com a identidade da sua organização?",
  lp2EmpresasWhiteLabelDesc: "A solução White Label usa a infraestrutura Extraconomy para criar um ambiente próprio de participantes, negócios e benefícios.",
  lp2EmpresasWhiteLabelLink: "Conhecer White Label",
  lp2EmpresasStepEyebrow: "Um passo de cada vez",
  lp2EmpresasStepTitle: "Comece pelo problema que sua empresa quer resolver.",
  lp2EmpresasStepDesc: "Nossa conversa parte da necessidade: benefícios, relacionamento, rede comercial ou ambiente próprio.",
  lp2EmpresasCtaTitle: "Vamos entender o seu caso?",
  lp2EmpresasCtaDesc: "Conte o que sua empresa precisa. A solução vem depois.",
  lp2EmpresasCtaButton: "Falar com a equipe",
  lp2PlanosSeoDescription: "Compare Store, Partner, Seller e Manager na Extraconomy.",
  lp2PlanosBreadcrumb: "Planos",
  lp2PlanosEyebrow: "Planos",
  lp2PlanosH1: "Escolha pelo tamanho da sua operação.",
  lp2PlanosHeroDesc:
    "Comece gratuito com Store ou escolha uma estrutura de venda online. Compare apenas o que muda entre os planos.",
  lp2PlanosCompareEyebrow: "Comparação simples",
  lp2PlanosCompareTitle: "Veja as diferenças que realmente importam.",
  lp2PlanosCompareDesc: "Se um plano fizer sentido, entre na página dele para conhecer os detalhes.",
  lp2PlanosStoreDesc: "Loja física no mapa.",
  lp2PlanosStoreItem1: "Cadastro gratuito",
  lp2PlanosStoreItem2: "Conta geolocalizada",
  lp2PlanosStoreItem3: "Certificação no mapa",
  lp2PlanosStoreCta: "Conhecer Store",
  lp2PlanosPartnerDesc: "€150/ano · até 50 anúncios.",
  lp2PlanosPartnerItem1: "Vitrine online",
  lp2PlanosPartnerItem2: "Rede econômica",
  lp2PlanosPartnerItem3: "Renovação €15/ano",
  lp2PlanosPartnerCta: "Conhecer Partner",
  lp2PlanosSellerDesc: "€350/ano · até 500 anúncios.",
  lp2PlanosSellerItem1: "E-commerce pessoal",
  lp2PlanosSellerItem3: "Renovação €35/ano",
  lp2PlanosSellerCta: "Conhecer Seller",
  lp2PlanosManagerDesc: "€1.500/ano · anúncios ilimitados.",
  lp2PlanosManagerItem1: "Loja online",
  lp2PlanosManagerItem2: "Geolocalização",
  lp2PlanosManagerItem3: "Renovação €150/ano",
  lp2PlanosManagerCta: "Conhecer Manager",
  lp2PlanosDisclaimer: "Valores e condições devem ser confirmados no momento da contratação.",
  lp2PlanosCtaTitle: "Ainda em dúvida?",
  lp2PlanosCtaDesc: "Comece pela Store gratuita ou conheça cada plano com mais calma.",
  lp2PlanosCtaButton: "Começar pela Store",
  lp2SobreSeoDescription: "Conheça a ideia por trás da Extraconomy e como sua rede conecta pessoas e negócios.",
  lp2SobreBadge: "Sobre a Extraconomy",
  lp2SobreH1: "Uma rede criada para fazer o valor circular.",
  lp2SobreHeroDesc: "A Extraconomy aproxima quem compra, quem vende e quem cria novas conexões para fortalecer relações econômicas mais próximas.",
  lp2SobreCta1: "Ver onde eu entro",
  lp2SobreCta2: "Conhecer empresas",
  lp2SobreIdeaEyebrow: "Nossa ideia",
  lp2SobreIdeaTitle: "Tecnologia só faz sentido quando melhora relações reais.",
  lp2SobreIdeaDesc: "Por isso, a Extraconomy reúne marketplace, benefícios, fidelidade e ferramentas para ajudar pessoas, negócios e organizações a participarem da mesma rede.",
  lp2SobreValue1Title: "Pessoas no centro",
  lp2SobreValue1Desc: "A experiência começa pelo que alguém quer fazer, não pela tecnologia que existe por trás.",
  lp2SobreValue2Title: "Negócios reais",
  lp2SobreValue2Desc: "Lojas físicas e vendedores online fazem parte da mesma economia conectada.",
  lp2SobreValue3Title: "Valor em circulação",
  lp2SobreValue3Desc: "Benefícios incentivam novas relações dentro da própria rede.",
  lp2SobreInfraEyebrow: "De um marketplace para uma infraestrutura",
  lp2SobreInfraTitle: "A mesma lógica pode atender pessoas, empresas e comunidades.",
  lp2SobreInfraDesc: "O marketplace é uma parte importante. Extrapay, soluções corporativas e White Label ampliam essa base para outros contextos sem perder a ideia central: conectar pessoas e negócios de forma simples.",
  lp2SobreInfraImgAlt: "Negócio local da economia Extraconomy",
  lp2SobreCtaTitle: "Onde você entra nessa rede?",
  lp2SobreCtaDesc: "Escolha pela atividade que faz sentido para você hoje.",
  lp2SobreCtaButton: "Conhecer perfis",
  lp2VideoEyebrow: "Conheça a Extraconomy",
  lp2VideoTitle: "Uma economia que fica com quem participa.",
  lp2VideoDescription: "Em poucos minutos, nosso fundador apresenta o ecossistema que conecta cidadãos, comércios, profissionais e associações em uma mesma rede de benefícios.",
  lp2VideoLanguageNote: "Vídeo em italiano, com legendas automáticas no seu idioma. Se elas não aparecerem, ative pelo botão CC do player.",
  lp2VideoPlay: "Assistir ao vídeo",
};

export default landingDictPT;
